import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, apiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useNoIndex, codiceKey } from "@/components/accordi/accordiUtils";
import { toast } from "sonner";
import { Handshake, Loader2 } from "lucide-react";

// Ingresso unico (anche dal sito assietica.it): codice accordo -> area riservata dell'accordo.
export default function AccordoAccesso() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [codice, setCodice] = useState((params.get("codice") || "").toUpperCase());
  const [busy, setBusy] = useState(false);
  useNoIndex();

  const accedi = async (c = codice) => {
    setBusy(true);
    try {
      const { data } = await api.get(`/public/accordi/codice/${encodeURIComponent(c.trim())}`);
      sessionStorage.setItem(codiceKey(data.slug), c.trim().toUpperCase());
      navigate(`/accordi/${data.slug}/area`, { replace: true });
    } catch (e) { toast.error(apiError(e)); setBusy(false); }
  };

  useEffect(() => { if (params.get("codice")) accedi(params.get("codice")); }, []); // eslint-disable-line

  return (
    <div className="flex min-h-screen items-center justify-center bg-bone px-4" data-testid="accordo-accesso">
      <div className="w-full max-w-md space-y-5 rounded-2xl border bg-white p-8 shadow-sm">
        <Handshake className="h-8 w-8 text-terracotta" />
        <h1 className="font-heading text-3xl font-semibold text-forest">Accordi di Maggior Favore</h1>
        <p className="text-sm text-muted-foreground">Inserisci il codice dell'accordo del tuo ente per accedere all'area riservata e calcolare il tuo preventivo.</p>
        <Input value={codice} onChange={(e) => setCodice(e.target.value.toUpperCase())} onKeyDown={(e) => e.key === "Enter" && codice && accedi()} placeholder="Codice accordo" data-testid="accesso-codice" className="h-11 text-center font-mono tracking-widest" />
        <Button onClick={() => accedi()} disabled={!codice || busy} data-testid="accesso-entra" className="h-11 w-full bg-terracotta hover:bg-terracotta-hover">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Entra</Button>
      </div>
    </div>
  );
}
